// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"9ae7d5ec","151":"c12f9e21","314":"51724ff0","626":"4c68a991","739":"94ade9a8"}[chunkId] + ".chunk.js";
};